import {Component} from 'react';
import React from 'react';
import Chart from "react-google-charts";
import ValidatedFormComponent from "../ValidatedFormComponent";
import {Row} from "react-bootstrap";
import TopBar from "../TopBar";

class VMSub extends Component {
    constructor(props) {
        /*
            - revenues
            - revalues
            - currency
        */
        super(props);

        this.state = {
        };

        this.state.possibleYears = [];
        this.state.perYearArrays = {};

        if(this.props.revenues!=null &&
            this.props.revenues.currentEndTimestamp!==null &&
            this.props.revenues.currentEndTimestamp!==undefined &&
            this.props.revenues.currentStartTimestamp!==null &&
            this.props.revenues.currentStartTimestamp!==undefined &&
            this.props.revenues.currentTotal!==null &&
            this.props.revenues.currentTotal!==undefined) {

            const date = new Date(this.props.revenues.currentStartTimestamp);
            const year = date.getUTCFullYear();
            if(!this.state.possibleYears.includes(year)) this.state.possibleYears.push(year);
            if(this.state.perYearArrays[year]==null) this.state.perYearArrays[year]={};
            this.state.perYearArrays[year][date.getUTCMonth()]={
                revenue: this.props.revenues.currentTotal
            };
        }

        if(this.props.revenues!=null && this.props.revenues.history!=null) for(let entry of this.props.revenues.history) {
            const date = new Date(entry.monthStart);
            const year = date.getUTCFullYear();
            if(!this.state.possibleYears.includes(year)) this.state.possibleYears.push(year);
            if(this.state.perYearArrays[year]==null) this.state.perYearArrays[year]={};
            this.state.perYearArrays[year][date.getUTCMonth()]={
                revenue: entry.amount
            };
        }



        if(this.props.revalues!=null &&
            this.props.revalues.currentEndTimestamp!==null &&
            this.props.revalues.currentEndTimestamp!==undefined &&
            this.props.revalues.currentStartTimestamp!==null &&
            this.props.revalues.currentStartTimestamp!==undefined &&
            this.props.revalues.currentTotal!==null &&
            this.props.revalues.currentTotal!==undefined) {

            const date = new Date(this.props.revalues.currentStartTimestamp);
            const year = date.getUTCFullYear();
            if(!this.state.possibleYears.includes(year)) this.state.possibleYears.push(year);
            if(this.state.perYearArrays[year]==null) this.state.perYearArrays[year]={};
            if(this.state.perYearArrays[year][date.getUTCMonth()]==null) this.state.perYearArrays[year][date.getUTCMonth()]={};
            this.state.perYearArrays[year][date.getUTCMonth()].revalue=this.props.revalues.currentTotal;
        }

        if(this.props.revalues!=null && this.props.revalues.history!=null) for(let entry of this.props.revalues.history) {
            const date = new Date(entry.monthStart);
            const year = date.getUTCFullYear();
            if(!this.state.possibleYears.includes(year)) this.state.possibleYears.push(year);
            if(this.state.perYearArrays[year]==null) this.state.perYearArrays[year]={};
            if(this.state.perYearArrays[year][date.getUTCMonth()]==null) this.state.perYearArrays[year][date.getUTCMonth()]={};
            this.state.perYearArrays[year][date.getUTCMonth()].revalue=entry.amount;
        }

        if(this.state.possibleYears.length===0) this.state.possibleYears.push(new Date().getUTCFullYear());

        this.state.possibleYears.sort();
        this.state.possibleYears.reverse();

        this.state.selectedYear = this.state.possibleYears[0];

    }

    getMonthName(index) {

        switch (index) {
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            case 11:
                return "December";
            default:
                return "Unrecognized month";
        }

    }
    
    render() {

        const yearSelection = [];

        for(let yr of this.state.possibleYears) {
            yearSelection.push({
                name: ""+yr,
                value: yr
            })
        }

        const tableData = [];

        tableData[0] = ['Month', 'Monthly revenue', 'Monthly revalue'];

        for(let i=0;i<12;i++) {
            let entry = this.state.perYearArrays[this.state.selectedYear]==null ? null :
                            this.state.perYearArrays[this.state.selectedYear][i];
            if(entry==null) entry={};
            let revenue = 0;
            let revalue = 0;
            if(entry.revenue!==null && entry.revenue!==undefined) revenue = entry.revenue;
            if(entry.revalue!==null && entry.revalue!==undefined) revalue = entry.revalue;
            tableData.push([this.getMonthName(i),revenue,revalue]);
        }

        return (
            <div>
                <ValidatedFormComponent
                        type="select"
                        onValidate={() => null}
                        display_name_key="name"
                        value_key="value"
                        options={yearSelection}
                        onChange={(value) => {
                            this.setState({
                                selectedYear: value
                            });
                        }}
                        value={this.state.selectedYear}
                    />
                <br/>
                <br/>
                    <Chart
                        height={300}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart...</div>}
                        data={tableData}
                        options={{
                            title: 'Monthly revenues and revalues',
                            backgroundColor: 'rgb(238, 238, 238)',
                            vAxis: {
                                title: 'Amount in '+this.props.currency,
                                minValue: 0,
                                format: '0.00'
                            },
                            hAxis: {
                                title: 'Month',
                            },
                        }}
                        legendToggle
                    />
            </div>
        );
    }
}

export default VMSub;